import { theme as mbTheme } from '@material-bank/mb-uikit/theme';
import deepmerge from 'deepmerge';

declare module 'theme-ui' {
  interface Theme {}
}

export const theme = deepmerge(
  mbTheme,
  {
    zIndices: {
      dropdownMenu: 9,
      overlayZendeskButton: 1000000,
    },

    styles: {
      root: {
        bg: 'unset',
      },
    },
  },
  {
    arrayMerge: (_target, source) => source,
  },
);
